module.exports = __webpack_public_path__ + "static/media/thunderBay.3713e680.jpg";